import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { CONSENT_COMMUNITY_API } from "./apiRoutes";

interface getProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getMyOwnedProperties = async (communityId: string) =>
  await axiosAuth.get(`${CONSENT_COMMUNITY_API(communityId)}/my-owned-properties`);

const useGetMyOwnedProperties = ({
  communityId,
  queryParams
}: getProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["my-owned-properties", communityId],
    queryFn: () => getMyOwnedProperties(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetMyOwnedProperties;
